<template>
<div class="chapter">
<div class="inner_page">
<p class="ded-t"><a id="page_4">Dedicated to Zafar Ismail, Tim and Rachel Green, partners in cross-cultural mission</a></p><a id="page_4">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 004_Dedication.vue?23fc31d5